import { useMutation } from '@tanstack/react-query';

import type { MutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

const useCatalogUrlMutation = (method: 'PUT' | 'DELETE') =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<MutationResponse>({ method, url }),
  });

export const useArchiveCatalogServiceCategoryMutation = () =>
  useCatalogUrlMutation('PUT');

export const useRestoreCatalogServiceCategoryMutation = () =>
  useCatalogUrlMutation('PUT');

export const useDeleteCatalogServiceCategoryMutation = () =>
  useCatalogUrlMutation('DELETE');

export const useArchiveCatalogServiceMutation = () =>
  useCatalogUrlMutation('PUT');

export const useRestoreCatalogServiceMutation = () =>
  useCatalogUrlMutation('PUT');

export const useDeleteCatalogServiceMutation = () =>
  useCatalogUrlMutation('DELETE');

// Move reparents the record; `ids` is the target parent's full ordered children list.

export const useMoveCatalogServiceCategoryMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: { parent_id: number | null; ids: number[] };
    }) =>
      HttpClient.request<MutationResponse>({
        method: 'PUT',
        url: params.url,
        data: params.data,
      }),
  });

export const useMoveCatalogServiceMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: { service_category_id: number; ids: number[] };
    }) =>
      HttpClient.request<MutationResponse>({
        method: 'PUT',
        url: params.url,
        data: params.data,
      }),
  });
